import type { Grading } from "@/lib/fantasy-props/rows";
import type { SlipLegView, SlipPrice, SlipTarget } from "@/lib/fantasy-props/slip";
import { pick6Pricing, type Pick6QuoteState } from "./use-pick6-quote";
import { underdogPricing, type UnderdogQuoteState } from "./use-underdog-quote";
import type { SlipPricing } from "./use-slip-quote";

const UNPRICED: SlipPricing = { live: null, price: null, tiers: undefined, mismatch: false };

export function slipPricing(grading: Grading, underdog: UnderdogQuoteState, pick6: Pick6QuoteState, target: SlipTarget | null, price: SlipPrice | null, legs: readonly SlipLegView[]): SlipPricing {
  if (grading.kind === "ungraded" || price === null) return UNPRICED;
  return underdog.status !== "off" ? underdogPricing(underdog, target, price, legs, grading.standard) : pick6Pricing(pick6, target, price);
}

export function noStandardText(book: string): string {
  return `${book}'s standard payout hasn't loaded, so Upside can't price this slip`;
}
